import React from 'react';
import Styles from './index.module.scss';

interface Props {
    children: string;
}
const Index = ({children}: Props) => {
    return <div className={Styles.title}>{children}</div>;
};

export default Index;
